import { experimentBucket } from "./experimentBucket";
import {
  isUnlimitedOnlyEligibleUser,
  TUnlimitedOnlyEligibilityUser,
} from "./unlimitedOnlyPaywall";

// ALL-2079: the earn loop is tested on the same population as the
// unlimited-only price test, split independently by its own id. quentin's
// helpers/earnLoop makes the same call from the same inputs; if the two ever
// disagree, the modal offers a claim the backend refuses.
export const EARN_LOOP_EXPERIMENT = "earn_loop_v1";
export type EarnLoopVariant = "control" | "treatment";

// Sends every player back to control without a code change.
export const EARN_LOOP_KILLED = process.env.REACT_APP_EARN_LOOP_KILL === "true";

export const earnLoopVariant = (userId: string): EarnLoopVariant =>
  experimentBucket(EARN_LOOP_EXPERIMENT, userId) < 0.5
    ? "control"
    : "treatment";

// Null means outside the experiment, which readouts must not count as control.
export const earnLoopVariantOf = (
  user?: (TUnlimitedOnlyEligibilityUser & { _id?: string }) | null,
): EarnLoopVariant | null => {
  if (!user?._id || !isUnlimitedOnlyEligibleUser(user)) return null;
  return EARN_LOOP_KILLED ? "control" : earnLoopVariant(user._id);
};
